import {Injectable} from "@angular/core";
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {catchError, Observable, of, throwError} from "rxjs";
import {Router} from "@angular/router";
import {AuthService} from "../../modules/auth/services/auth-service";

@Injectable()
export class AuthInterceptadorService implements HttpInterceptor{
  constructor(private router: Router,
              private tokenService: AuthService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.tokenService.AccessToken;

    if(req.headers.get(`Authorization`) != undefined)
      return next.handle(req);

    if(token !== null){
      const novoRequest = req.clone({
        headers: req.headers.set(`Authorization`, `Bearer ` + token?.accessToken),
      });

      return next.handle(novoRequest)
        .pipe(
          catchError(error => {
            if (error.status === 401 || error.status === 403) {
              this.tokenService.logoff();
              return of();
            }
            return throwError(error);
          })
        );
    }
    else{
      return next.handle(req);
    }
  }
}

